import * as React from "react";
import { cn } from "@/lib/utils";

import { Link as I18nLink } from "@/i18n/routing";

type CustomLinkProps = React.ComponentProps<typeof I18nLink> & {
  className?: string;
  children?: React.ReactNode;
  target?: "_blank" | "_self" | "_parent" | "_top";
  color?: string;
  href: string;
};

/**
 * Link Component
 *
 * A styled wrapper for the localized I18nLink that supports custom colors,
 * targets, and ref forwarding. Ensures consistent link styling across the app.
 */
const Link = React.forwardRef<HTMLAnchorElement, CustomLinkProps>(
  ({ className, children, target, color, ...props }, ref) => {
    return (
      <a
        ref={ref}
        className={cn(
          `${color ?? "text-blue-700"} text-base no-underline`,
          className,
        )}
        {...(target ? { target } : {})}
        {...props}
      >
        {children}
      </a>
    );
  },
);

Link.displayName = "Link";

export { Link };
